import { mapActions, mapGetters } from "vuex";

export const structureMixin = {
  computed: {
    ...mapGetters({
      structs: "structure/list/items",
      structures: "structure/listRob/items",
      structuresIsLoading: "structure/list/isLoading",
      structuresRobIsLoading: "structure/listRob/isLoading",
    }),
  },
  methods: {
    ...mapActions({
      getStructures: "structure/listRob/getItems",
      getStructs: "structure/list/getItems",
    }),
  },
};
